import styled, { css } from 'styled-components';
import { TextField } from '@material-ui/core';

export const Text = styled(TextField)`
  width: ${(props) => props.width} !important;
  height: ${(props) => (props.height ? props.height : 'auto')} !important;
  background-color: ${(props) => props.theme.colors.veryDarkGray};
  margin: ${(props) => props.margin || '0'};

  input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 30px ${(props) => props.theme.colors.veryLightGray_4} inset;
  }

  .Mui-focused {
    margin-left: 0;
  }
  .MuiInputLabel-root,
  .MuiInputBase-root {
    background-color: transparent;
  }

  .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl,
  .MuiInputBase-input.MuiInput-input {
    margin-left: ${(props) => props.spacelabelinput ?? '0.2vw'};
  }

  .PrivateNotchedOutline-root-19 {
    padding: 0;
  }
  .PrivateNotchedOutline-root-20 {
    padding: 0 !important;
  }
`;
